<section class="wraper-sub">
  <div class="order-management-m qa-order-management">
    <div class="top-page-m">
      <div class="top-section">
        <h1 class="page-name">Order Management</h1>

        <div class="price-top-m">
          <p class="price-sub" data-toggle="modal" data-target="#year_selection">
            <span *ngIf="leads.totalPay != 0">$ {{ leads.totalPay | number }}</span>
            <span *ngIf="leads.totalPay == 0">$ 0</span>
            <i class="fa fa-caret-down" aria-hidden="true" *ngIf="leads.totalPay"></i>
          </p>

          <div class="year-selection-m" *ngIf="leads.totalPay">
            <!-- Modal -->
            <div class="modal fade" id="year_selection" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
              <div class="modal-dialog" role="document">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">Total : $ {{ leads.totalPay | number }}</h5>
                </div>
                <div class="modal-content">
                  <div class="modal-body">
                    <ul class="year-selection-p">
                      <ng-container *ngFor="let paymentPart of leads.dispositionTotal">
                        <li *ngIf="paymentPart.status != 0" [title]="totalPaymentSearch(paymentPart.status, orderStatus)">
                          <label>{{ totalPaymentSearch(paymentPart.status, orderStatus) }}</label>
                          <span>$ {{ paymentPart.totpay | number }}</span>
                        </li>
                        
                        <!-- <li *ngIf="(leads.data && leads.data.length > 0)">
                          <label>Have Many</label>
                          <span>{{ leads.manyOrderCount | number }}</span>
                        </li>
                        <li *ngIf="(leads.data && leads.data.length > 0)">
                          <label>Have One</label>
                          <span>{{ leads.oneOrderCount | number }}</span>
                        </li> -->
                      </ng-container>
                      <li *ngIf="(leads.data && leads.data.length > 0)">
                        <label>Returning Cust.</label>
                        <span>{{ leads.manyOrderCount | number }}</span>
                      </li>
                      <li *ngIf="(leads.data && leads.data.length > 0)">
                        <label>New Cust.</label>
                        <span>{{ leads.oneOrderCount | number }}</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="filter-sub-m">
        <div class="filter-m">
          <div class="filter">
            <div class="fields-m">
              <input type="text" name="search" (change)="rerender()" [(ngModel)]="searchParams.emailId" placeholder="Search by Order ID">
              <i class="fa fa-search" aria-hidden="true" (change)="rerender()" (click)="rerender()"></i>
            </div>
          </div>
          <div class="filter">
            <div class="fields-m date-filter">
              <input (onHidden)="splitFromTo()" [(ngModel)]="fullRangeDate" type="text" placeholder="Date Range" bsDaterangepicker [bsConfig]="{ isAnimated: true, showWeekNumbers: false}">
              <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M13.2422 1.17188H12.5391V0H11.3672V1.17188H3.63281V0H2.46094V1.17188H1.75781C0.788555 1.17188 0 1.96043 0 2.92969V13.2422C0 14.2114 0.788555 15 1.75781 15H13.2422C14.2114 15 15 14.2114 15 13.2422V2.92969C15 1.96043 14.2114 1.17188 13.2422 1.17188ZM13.8281 13.2422C13.8281 13.5653 13.5653 13.8281 13.2422 13.8281H1.75781C1.43473 13.8281 1.17188 13.5653 1.17188 13.2422V5.50781H13.8281V13.2422ZM13.8281 4.33594H1.17188V2.92969C1.17188 2.6066 1.43473 2.34375 1.75781 2.34375H2.46094V3.51562H3.63281V2.34375H11.3672V3.51562H12.5391V2.34375H13.2422C13.5653 2.34375 13.8281 2.6066 13.8281 2.92969V4.33594Z"
                  fill="#1C212D" />
                <path d="M3.39844 6.73828H2.22656V7.91016H3.39844V6.73828Z" fill="#1C212D" />
                <path d="M5.74219 6.73828H4.57031V7.91016H5.74219V6.73828Z" fill="#1C212D" />
                <path d="M8.08643 6.73828H6.91455V7.91016H8.08643V6.73828Z" fill="#1C212D" />
                <path d="M10.4297 6.73828H9.25781V7.91016H10.4297V6.73828Z" fill="#1C212D" />
                <path d="M12.7734 6.73828H11.6016V7.91016H12.7734V6.73828Z" fill="#1C212D" />
                <path d="M3.39844 9.08203H2.22656V10.2539H3.39844V9.08203Z" fill="#1C212D" />
                <path d="M5.74219 9.08203H4.57031V10.2539H5.74219V9.08203Z" fill="#1C212D" />
                <path d="M8.08643 9.08203H6.91455V10.2539H8.08643V9.08203Z" fill="#1C212D" />
                <path d="M10.4297 9.08203H9.25781V10.2539H10.4297V9.08203Z" fill="#1C212D" />
                <path d="M3.39844 11.4258H2.22656V12.5977H3.39844V11.4258Z" fill="#1C212D" />
                <path d="M5.74219 11.4258H4.57031V12.5977H5.74219V11.4258Z" fill="#1C212D" />
                <path d="M8.08643 11.4258H6.91455V12.5977H8.08643V11.4258Z" fill="#1C212D" />
                <path d="M10.4297 11.4258H9.25781V12.5977H10.4297V11.4258Z" fill="#1C212D" />
                <path d="M12.7734 9.08203H11.6016V10.2539H12.7734V9.08203Z" fill="#1C212D" />
              </svg>

            </div>
          </div>
          <div class="filter">
            <div class="fields-m select-m">
              <ng-select
                [items]="siteList"
                bindLabel="site_link"
                bindValue="site_link"
                placeholder="Site"
                appendTo="body"
                [(ngModel)]="searchParams.site_link"
                [ngModelOptions]="{standalone: true}"
                [searchable]="false"
                [clearable]="true"
                (change)="rerender()"
                >
                <ng-template ng-option-tmp let-item="item" let-index="index">
                  {{ item.site_link }}
                </ng-template>
              </ng-select>
            </div>
          </div>
          <div class="filter" *ngIf="activeUser.Portal_SuperAdmin">
            <div class="fields-m select-m multi-select">
              <ng-select
                [items]="documentTypeArray"
                multiple="true"
                placeholder="Document Type"
                appendTo="body"
                [(ngModel)]="searchParams.work_type"
                [ngModelOptions]="{standalone: true}"
                [searchable]="false"
                [clearable]="true"
                (change)="rerender()"
                >
                <ng-template ng-option-tmp let-item="item" let-index="index">
			        {{ item }}
			    </ng-template>
              </ng-select>
            </div>
          </div>


          <div class="filter">
            <div class="fields-m select-m">
              <ng-select
                [items]="orderTypeArray"
                bindLabel="name"
                bindValue="value"
                appendTo="body"
                placeholder="Order Type"
                [(ngModel)]="searchParams.order_type"
                [ngModelOptions]="{standalone: true}"
                [searchable]="false"
                [clearable]="true"
                (change)="rerender()"
                >
                <ng-template ng-option-tmp let-item="item" let-index="index">
                  {{ item.name }}
                </ng-template>
              </ng-select>
            </div>
          </div>
          
          <div class="filter">
            <div class="fields-m select-m">
              <ng-select
                [items]="paymentStatus"
                bindLabel="name"
                bindValue="value"
                appendTo="body"
                placeholder="Payment Status"
                [(ngModel)]="searchParams.half_price"
                [ngModelOptions]="{standalone: true}"
                [searchable]="false"
                [clearable]="true"
                (change)="rerender()"
                >
                <ng-template ng-option-tmp let-item="item" let-index="index">
                  {{ item.name }}
                </ng-template>
              </ng-select>
            </div>
          </div>
          <div class="filter">
            <div class="fields-m select-m">
              <ng-select
                [items]="orderStatus"
                bindLabel="name"
                bindValue="value"
                appendTo="body"
                placeholder="Order Status"
                [(ngModel)]="searchParams.orderStatus"
                [ngModelOptions]="{standalone: true}"
                [searchable]="false"
                [clearable]="true"
                (change)="rerender()"
                >
                <ng-template ng-option-tmp let-item="item" let-index="index">
                  {{ item.name }}
                </ng-template>
              </ng-select>
            </div>
          </div>
          <div class="filter">
            <div class="fields-m select-m">
              <ng-select
                [items]="returning_user"
                bindLabel="name"
                bindValue="value"
                appendTo="body"
                placeholder="Returning/ New"
                [(ngModel)]="searchParams.returning_user"
                [ngModelOptions]="{standalone: true}"
                [searchable]="false"
                [clearable]="true"
                (change)="rerender()"
                >
                <ng-template ng-option-tmp let-item="item" let-index="index">
                  {{ item.name }}
                </ng-template>
              </ng-select>
            </div>
          </div>

          <div class="filter price-slider" id="priceSlider" data-toggle="dropdown" *ngIf="!activeUser.is_qualityassurance">
            <a href="javascript:;">
              <ng-container *ngIf="searchParams.min_amount <= 0">Price</ng-container>
              <ng-container *ngIf="searchParams.min_amount > 0 && searchParams.max_amount == 10000">{{searchParams.min_amount}} - {{maxPriceLabel.name}}</ng-container>
              <ng-container *ngIf="searchParams.max_amount < 10000">{{searchParams.min_amount}} - {{searchParams.max_amount}}</ng-container>
              <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.51762 0H0.482355C0.0547937 0 -0.163021 0.565329 0.143533 0.900994L4.66117 5.84763C4.84671 6.05079 5.15326 6.05079 5.33889 5.84763L9.85652 0.900994C10.163 0.565329 9.94518 0 9.51762 0Z" fill="#1C212D" />
              </svg>
            </a>
            <div class="dropdown-menu" aria-labelledby="priceSlider">
              <ngx-slider (userChangeEnd)="rerender()" [(value)]="searchParams.min_amount" [(highValue)]="searchParams.max_amount" [options]="options"></ngx-slider>
              <!-- <div class="minMaxPrices d-flex justify-content-center">
                <div class="single">
                  <label for="#minVal">Min</label>
                  <input id="minVal" type="number" [min]="searchParams.min_amount" [(ngModel)]="searchParams.min_amount" (change)="rerender()">
                </div>
                <div class="single">
                  <label for="#maxVal">Max</label>
                  <input id="maxVal" type="number" [max]="searchParams.max_amount" [(ngModel)]="searchParams.max_amount" (change)="rerender()">
                </div>
              </div> -->
            </div>
          </div>

          <div class="filter" *ngIf="activeUser.is_qualityassurance">
            <div class="fields-m select-m">
              <ng-select [items]="verifiedStatusesForFilter" appendTo="body" bindLabel="name" bindValue="value" placeholder="All Sales" [(ngModel)]="searchParams.verified_sales" [ngModelOptions]="{standalone: true}" [searchable]="true" [clearable]="true"
                (change)="rerender()">
                <ng-template ng-option-tmp let-item="item" let-index="index">
                  {{ item.name }}
                </ng-template>
              </ng-select>
            </div>
          </div>

          <div class="filter">
            <div class="fields-m select-m multi-select">
              <ng-select
                [items]="agents"
                bindLabel="name"
                multiple="true"
                appendTo="body"
                bindValue="id"
                placeholder="Select Agent"
                [(ngModel)]="searchParams.agent_id"
                [ngModelOptions]="{standalone: true}"
                [searchable]="true"
                [clearable]="true"
                [closeOnSelect]="false"
                (change)="rerender()"
                >
                <ng-template ng-option-tmp let-item="item" let-index="index">
                  <input [checked]="searchParams.agent_id.indexOf(item.id) > -1" type="checkbox">
                  {{ item.name }}
  					    </ng-template>
              </ng-select>
            </div>
          </div>

          <div class="filter">
            <div class="fields-m select-m multi-select">
              <ng-select
                [items]="writers"
                bindLabel="name"
                multiple="true"
                appendTo="body"
                bindValue="id"
                placeholder="Select Writer"
                [(ngModel)]="searchParams.writer_id"
                [ngModelOptions]="{standalone: true}"
                [searchable]="true"
                [clearable]="true"
                [closeOnSelect]="false"
                (change)="rerender()"
                >
                <ng-template ng-option-tmp let-item="item" let-index="index">
                  <input [checked]="searchParams.writer_id.indexOf(item.id) > -1" type="checkbox">
                  {{ item.name }}
  					    </ng-template>
              </ng-select>
            </div>
          </div>

          <div class="clear-m">
            <div class="clear" (click)="clearFilters()">
              <span>Clear</span>
              <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M16.502 14.4612L11 14.5L16.3175 8.9606C16.7574 8.50197 16.9996 7.89224 16.9996 7.24366C16.9996 6.59515 16.7574 5.98539 16.3175 5.52676L12.178 1.21004C11.2701 0.263319 9.79293 0.263319 8.88506 1.21004L0.682059 9.76415C0.242217 10.2228 0 10.8325 0 11.4811C0 12.1296 0.242217 12.7394 0.682059 13.198L2.74371 15.3479C2.83711 15.4453 2.96378 15.5 3.09586 15.5H16.502C16.777 15.5 17 15.2675 17 14.9806C17 14.6938 16.777 14.4612 16.502 14.4612ZM7.83365 3.77541L9.14441 5.14226L5.12739 9.33125L3.81663 7.96439L7.83365 3.77541ZM11.8424 7.95567L7.82531 12.1446L5.8317 10.0657L9.84874 5.87674L11.8424 7.95567ZM12.5467 8.69015L13.8575 10.057L12.5138 11.4583L9.84048 14.246L8.52965 12.8791L12.5467 8.69015ZM9.58943 1.94452C10.1089 1.40283 10.9542 1.40283 11.4737 1.94452L15.6132 6.26124C16.1327 6.80297 16.1327 7.68442 15.6132 8.22612L14.5618 9.32256L8.53798 3.04093L9.58943 1.94452ZM1.38636 12.4635C1.13468 12.2011 0.996094 11.8521 0.996094 11.4811C0.996094 11.11 1.13468 10.7611 1.38633 10.4987L3.11226 8.69887L4.77514 10.4329L7.47309 13.2464L8.63816 14.4612H3.30215L1.38636 12.4635Z"
                  fill="#1C212D" />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="data-tables-m">
      <div class="table-responsive">
        <table class="row-border hover" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger">
          <thead>
            <tr>
              <th>Sr</th>
              <th>Order ID</th>
              <th>Timestamp</th>
              <th>Client info</th>
              <th>Subject</th>
              <th>Document Type</th>
              <th>Academic Level</th>
              <th>No. of Pages</th>
              <th>Due Date</th>
              <th>Price</th>
              <th>Payment Status</th>
              <th>Assigned To</th>
              <th>Writer D-D</th>
              <th>Agent</th>
              <th>Order Status</th>
              <th>Action</th>
              <th>Mark Verified</th>
              <th>Valid / Invalid</th>
              <th>Q/A Feedback</th>
              <th>Comments</th>
            </tr>
          </thead>

          <!-- For SuperAdmin -->
          <ng-container *ngIf="activeUser.Portal_SuperAdmin && (leads.data && leads.data.length > 0)">
            <tbody>
              <tr *ngFor="let lead of leads.data; let indx = index">
                <td>{{ indx + 1 }}</td>
                <td><a class="id" href="javascript:;" target="_blank" routerLink="/order-detail/{{ lead.id | base64 }}">{{ lead.order_id }}</a></td>

                <td>
                  <p *ngIf="lead.date">{{ lead.date | date }}</p>
                  <p>{{ lead.date | date:'shortTime' }}</p>
                </td>
                <td>
                  <div class="pos-rel" *ngIf="lead.many_order">
                    <a href="javascript:;" (click)="showManyOrder(lead, indx)">
                      {{ lead.name }}
                    </a>
                    
                    <div class="comment-modal-m">
                      <div class="modal fade" [id]="'many_order_modal' + indx" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel1" aria-hidden="true">
                        <div class="modal-dialog resize" role="document">
                          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                          </button>
                          <div class="modal-header">
                            <h5 class="modal-title left-align" id="exampleModalLabel1">
                              Orders Detail
                            </h5>
                            
                          </div>
                          <div class="modal-content">
                            <div class="modal-body text-start">
                              <div class="row parent">
                                <!-- Paid Orders Section -->
                                <div class="col-12">
                                  <div class="row">
                                    <div class="col"><b>Customer Since:</b></div>
                                    <div class="col">{{ many_orders_detail.first_paid_order_date | date: 'dd MMM yyyy' }}</div>
                                  </div>
                                  <div class="row">
                                    <div class="col"><b>Orders Till Date:</b></div>
                                    <div class="col">{{ many_orders_detail.total_paid_orders }}</div>
                                  </div>
                                  <div class="row">
                                    <div class="col"><b>Value of Orders:</b></div>
                                    <div class="col">${{ many_orders_detail.paid_orders_value.toFixed(2) }}</div>
                                  </div>
                                  <div class="row">
                                    <div class="col"><b>Last Order Date:</b></div>
                                    <div class="col">{{ many_orders_detail.last_paid_order_date | date: 'dd MMM yyyy' }}</div>
                                  </div>
                                 </div>
                      
                                <!-- Unpaid Orders Section -->
                                <!-- <div class="col-12">
                                  <h5>Unpaid</h5>
                                  <p><b>Total Orders Till Date:</b> {{ many_orders_detail.total_unpaid_orders }}</p>
                                  <p><b>Value of Orders:</b> ${{ many_orders_detail.unpaid_orders_value.toFixed(2) }}</p>
                                  <p><b>First Order Date:</b> {{ many_orders_detail.first_unpaid_order_date | date: 'dd MMM yyyy' }}</p>
                                  <p><b>Last Order Date:</b> {{ many_orders_detail.last_unpaid_order_date | date: 'dd MMM yyyy' }}</p>
                                </div> -->
                              </div>
                            
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  
                  </div>
                  <p *ngIf="!lead.many_order">{{ lead.name }}</p>
                  <p>{{ lead.phone }}</p>
                  <p>{{ lead.email }}</p>
                </td>
                <td>
                  <p>{{ lead.subject | capitalize }}</p>
                </td>
                <td>
                  <p>{{ lead.work_type | capitalize }}</p>
                </td>
                <td>
                  <p>{{ lead.level | capitalize }}</p>
                </td>
                <td>
                  <div class="pos-rel">
                    
                    <p class="page-td" *ngIf="!lead.updatingHalfPaid">{{ lead.pages }} Pages</p>
                  </div>

                  
                </td>
                <td>

                  <p *ngIf="lead.delivery_date == '0000-00-00 00:00:00' else showDD">-</p>
                  <ng-container #showDD>
                    <p>{{ lead.delivery_date | date }}</p>
                    <p>{{ lead.delivery_date | date:'shortTime' }}</p>
                  </ng-container>
                  <!-- <p [ngClass]="{'time-elapsed': lead.show_red_dd, 'time-left': !lead.show_red_dd}" *ngIf="lead.time_remaining_dd;else showDash">{{ lead.time_remaining_dd }}</p>
                  <ng-template #showDash>-</ng-template> -->

                </td>
                <td>
                  <div class="pos-rel">
                    <div class="edit_price">
                      <p class="halfpay" *ngIf="lead.half_price && !lead.updatingHalfPaid">
                        $ <span (click)="openMarkHalfFullPay(indx)" *ngIf="showprice != indx">{{ lead.amount }}</span>
                        <input (change)="editPrice(lead,indx);" (click)="preventCloseOnClick()" *ngIf="showprice == indx" type="number" [(ngModel)]="lead.amount" [ngModelOptions]="{standalone: true}">
                        <i (click)="showPrice(indx); preventCloseOnClick()" class="fa fa-pencil-square-o" aria-hidden="true"></i>
                      </p>
                      <p class="fullpay" *ngIf="!lead.half_price" >
                        $ <span (click)="openMarkHalfFullPay(indx)" *ngIf="showprice != indx">{{ lead.amount }}</span>
                        <input (change)="editPrice(lead,indx);" (click)="preventCloseOnClick()" *ngIf="showprice == indx" type="number" [(ngModel)]="lead.amount" [ngModelOptions]="{standalone: true}">
                        <i (click)="showPrice(indx); preventCloseOnClick()" class="fa fa-pencil-square-o" aria-hidden="true"></i>
                      </p>
                    </div>
                    <!-- <p class="page-td" *ngIf="!lead.updatingHalfPaid">{{ lead.pages }} Pages</p> -->

                    <!-- Action loader and Message -->
                    <i class="fa fa-spinner fa-spin" *ngIf="lead.updatingHalfPaid"></i>
                    <span class="actionUpdated" *ngIf="lead.halfUpdated">Updated</span>
                    <span class="actionUpdated" *ngIf="lead.priceUpdated">Price Updated</span>

                    <!-- Action Modal Full pay-->
                    <div class="paid-modal-m">
                      <div class="modal fade" [id]="'mark__half_full_modal_'+ indx" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel2" aria-hidden="true">
                        <div class="modal-dialog" role="document">
                          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                          </button>
                          <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel2">Are you sure you want to mark it as
                              <span *ngIf="lead.half_price">Full</span>
                              <span *ngIf="!lead.half_price">Half</span> Paid?
                            </h5>
                          </div>
                          <div class="modal-content">
                            <div class="modal-body">
                              <div class="action-btns">
                                <a href="javascript:;" data-dismiss="modal" aria-label="Close">NO</a>
                                <a href="javascript:;" data-dismiss="modal" aria-label="Close" class="yes-btn" [ngClass]="{'bgRed': !lead.half_price}" (click)="markHalfFullPay(indx, lead)">YES</a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </td>

                <td>
                  <p>{{ lead.half_price === 1 ?  'Half Payment' : 'Full Payment' }}</p>
                </td>
                

                <td>
                  <div class="fields-m assigned-field select-m">
                    <ng-select
                      [items]="writers"
                      placeholder="Select Writer"
                      [(ngModel)]="lead.writer_id"
                      [ngModelOptions]="{standalone: true}"
                      [searchable]="true"
                      [clearable]="false"
                      bindLabel="name"
                      bindValue="id"
                      (change)="updateWriter(lead, indx)"
                      *ngIf="!lead.loadingUpdateWork"
                      >
                      <!-- <ng-template ng-label-tmp let-item="item" *ngIf="lead.writer_id == 0">
                        Select Writer
                      </ng-template> -->
                      <ng-template ng-option-tmp let-item="item" let-index="index">
                        {{ item.name }}
                      </ng-template>
                    </ng-select>
                  </div>

                  <!-- Action loader and Message -->
                  <i class="fa fa-spinner fa-spin" *ngIf="lead.loadingUpdateWork"></i>
                  <p class="actionUpdated" *ngIf="lead.actionUpdated">Updated</p>
                  <p class="actionNotUpdated" *ngIf="lead.actionNotUpdated1">Not Updated</p>
                </td>

                <td>
                  <!-- Action loader -->
                  <i class="fa fa-spinner fa-spin" *ngIf="lead.loadingupdateRegion"></i>

                  <div class="fields-m assigned-field select-m datetime_N">
                    <ng-select
                      [items]="writersRegion"
                      placeholder="Select Region"
                      [(ngModel)]="lead.order_region"
                      [ngModelOptions]="{standalone: true}"
                      [searchable]="true"
                      [clearable]="false"
                      (change)="updateRegion(lead, indx)"
                      *ngIf="!lead.loadingupdateRegion"
                      >
                      <ng-template ng-label-tmp let-item="item" *ngIf="!lead.order_region">
                          Select Region
                      </ng-template>

                      <ng-template ng-option-tmp let-item="item" let-index="index">
                        <span *ngIf="item == ''">
                          Select Region
                        </span>

                        <span *ngIf="item != 0">
                          {{ item }}
                        </span>
                      </ng-template>
                    </ng-select>

                    <!-- Set Deadline -->
                    <!-- <label class="agent-label set-deadline">
                      <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M13.2422 1.17188H12.5391V0H11.3672V1.17188H3.63281V0H2.46094V1.17188H1.75781C0.788555 1.17188 0 1.96043 0 2.92969V13.2422C0 14.2114 0.788555 15 1.75781 15H13.2422C14.2114 15 15 14.2114 15 13.2422V2.92969C15 1.96043 14.2114 1.17188 13.2422 1.17188ZM13.8281 13.2422C13.8281 13.5653 13.5653 13.8281 13.2422 13.8281H1.75781C1.43473 13.8281 1.17188 13.5653 1.17188 13.2422V5.50781H13.8281V13.2422ZM13.8281 4.33594H1.17188V2.92969C1.17188 2.6066 1.43473 2.34375 1.75781 2.34375H2.46094V3.51562H3.63281V2.34375H11.3672V3.51562H12.5391V2.34375H13.2422C13.5653 2.34375 13.8281 2.6066 13.8281 2.92969V4.33594Z"
                          fill="#C4CDD5" />
                        <path d="M3.39844 6.73828H2.22656V7.91016H3.39844V6.73828Z" fill="#C4CDD5" />
                        <path d="M5.74219 6.73828H4.57031V7.91016H5.74219V6.73828Z" fill="#C4CDD5" />
                        <path d="M8.08643 6.73828H6.91455V7.91016H8.08643V6.73828Z" fill="#C4CDD5" />
                        <path d="M10.4297 6.73828H9.25781V7.91016H10.4297V6.73828Z" fill="#C4CDD5" />
                        <path d="M12.7734 6.73828H11.6016V7.91016H12.7734V6.73828Z" fill="#C4CDD5" />
                        <path d="M3.39844 9.08203H2.22656V10.2539H3.39844V9.08203Z" fill="#C4CDD5" />
                        <path d="M5.74219 9.08203H4.57031V10.2539H5.74219V9.08203Z" fill="#C4CDD5" />
                        <path d="M8.08643 9.08203H6.91455V10.2539H8.08643V9.08203Z" fill="#C4CDD5" />
                        <path d="M10.4297 9.08203H9.25781V10.2539H10.4297V9.08203Z" fill="#C4CDD5" />
                        <path d="M3.39844 11.4258H2.22656V12.5977H3.39844V11.4258Z" fill="#C4CDD5" />
                        <path d="M5.74219 11.4258H4.57031V12.5977H5.74219V11.4258Z" fill="#C4CDD5" />
                        <path d="M8.08643 11.4258H6.91455V12.5977H8.08643V11.4258Z" fill="#C4CDD5" />
                        <path d="M10.4297 11.4258H9.25781V12.5977H10.4297V11.4258Z" fill="#C4CDD5" />
                        <path d="M12.7734 9.08203H11.6016V10.2539H12.7734V9.08203Z" fill="#C4CDD5" />
                      </svg>
                      <input type="text" (onHidden)="updateWriterTime(lead,indx)" [(ngModel)]="lead.writer_delivery_date" placeholder="Set deadline" class="form-control" bsDatepicker
                        [bsConfig]="{ dateInputFormat: 'YYYY-MM-DD hh:mm' ,isAnimated: true, showWeekNumbers: false}">
                    </label> -->

                    <!-- Set Writer Deadline -->
                    <!-- <ng-container *ngIf="lead.is_verified"> -->
                    <ng-container>
                      <ng-template #popTemplate>
                        <div class="fiWrap">
                            <bs-datepicker-inline
                                [(bsValue)]="lead.writer_delivery_date"
                                [bsConfig]="{showWeekNumbers: false, dateInputFormat: 'YYYY-MM-DD HH:mm'}"
                              >
                            </bs-datepicker-inline>
                            <timepicker [(ngModel)]="lead.writer_delivery_date" [showMeridian]="false"></timepicker>
                        </div>
                      </ng-template>

                      <label class="agent-label set-deadline" *ngIf="!lead.updatingDD" [popover]="popTemplate" [outsideClick]="true" (onHidden)="updateWriterTime(lead, indx)" placement="auto">
                          <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M13.2422 1.17188H12.5391V0H11.3672V1.17188H3.63281V0H2.46094V1.17188H1.75781C0.788555 1.17188 0 1.96043 0 2.92969V13.2422C0 14.2114 0.788555 15 1.75781 15H13.2422C14.2114 15 15 14.2114 15 13.2422V2.92969C15 1.96043 14.2114 1.17188 13.2422 1.17188ZM13.8281 13.2422C13.8281 13.5653 13.5653 13.8281 13.2422 13.8281H1.75781C1.43473 13.8281 1.17188 13.5653 1.17188 13.2422V5.50781H13.8281V13.2422ZM13.8281 4.33594H1.17188V2.92969C1.17188 2.6066 1.43473 2.34375 1.75781 2.34375H2.46094V3.51562H3.63281V2.34375H11.3672V3.51562H12.5391V2.34375H13.2422C13.5653 2.34375 13.8281 2.6066 13.8281 2.92969V4.33594Z" fill="#C4CDD5"/>
                            <path d="M3.39844 6.73828H2.22656V7.91016H3.39844V6.73828Z" fill="#C4CDD5"/>
                            <path d="M5.74219 6.73828H4.57031V7.91016H5.74219V6.73828Z" fill="#C4CDD5"/>
                            <path d="M8.08643 6.73828H6.91455V7.91016H8.08643V6.73828Z" fill="#C4CDD5"/>
                            <path d="M10.4297 6.73828H9.25781V7.91016H10.4297V6.73828Z" fill="#C4CDD5"/>
                            <path d="M12.7734 6.73828H11.6016V7.91016H12.7734V6.73828Z" fill="#C4CDD5"/>
                            <path d="M3.39844 9.08203H2.22656V10.2539H3.39844V9.08203Z" fill="#C4CDD5"/>
                            <path d="M5.74219 9.08203H4.57031V10.2539H5.74219V9.08203Z" fill="#C4CDD5"/>
                            <path d="M8.08643 9.08203H6.91455V10.2539H8.08643V9.08203Z" fill="#C4CDD5"/>
                            <path d="M10.4297 9.08203H9.25781V10.2539H10.4297V9.08203Z" fill="#C4CDD5"/>
                            <path d="M3.39844 11.4258H2.22656V12.5977H3.39844V11.4258Z" fill="#C4CDD5"/>
                            <path d="M5.74219 11.4258H4.57031V12.5977H5.74219V11.4258Z" fill="#C4CDD5"/>
                            <path d="M8.08643 11.4258H6.91455V12.5977H8.08643V11.4258Z" fill="#C4CDD5"/>
                            <path d="M10.4297 11.4258H9.25781V12.5977H10.4297V11.4258Z" fill="#C4CDD5"/>
                            <path d="M12.7734 9.08203H11.6016V10.2539H12.7734V9.08203Z" fill="#C4CDD5"/>
                          </svg>

                          <span class="time-done" *ngIf="lead.writer_delivery_date">{{ lead.writer_delivery_date | customDatePipe: 'yyyy-mm-dd HH:mm' }}</span>
                          <span class="time-done" *ngIf="!lead.writer_delivery_date">Set Deadline</span>
                      </label>

                      <!-- Show Deadline Remaning time -->
                      <!-- <ng-container *ngIf="lead.writerDD_Col.timeRemaining">
                        <br *ngIf="lead.ddUpdated">
                        <p [ngClass]="{'time-left': !lead.writerDD_Col.invert, 'time-elapsed': lead.writerDD_Col.invert}">{{ lead.writerDD_Col.timeRemaining }}</p>
                      </ng-container> -->
                    </ng-container>
                  </div>

                  <!-- Action Message -->
                  <p class="actionUpdated" *ngIf="lead.regionUpdated">Region Updated</p>
                  <p class="actionNotUpdated" *ngIf="lead.actionNotUpdated2">Region Not Updated</p>

                  <!-- Due date Loader and Message -->
                  <i class="fa fa-spinner fa-spin" *ngIf="lead.updatingDD"></i>
                  <span class="actionUpdated" *ngIf="lead.ddUpdated">Due Date Updated</span>

                  <p [ngClass]="{'time-elapsed': lead.writer_invert, 'time-left': !lead.writer_invert}" *ngIf="lead.timeRemaining">{{ lead.timeRemaining }}</p>
                </td>

                <td>
                  <div class="fields-m assigned-field select-m">
                    <label class="agent-label" *ngFor="let singleAgent of lead.agent.split(',')">{{ singleAgent }}</label>
                    <ng-select
                      [items]="select2Agents"
                      placeholder="Select Agent"
                      [(ngModel)]="lead.agent_concat_id"
                      [ngModelOptions]="{standalone: true}"
                      [searchable]="true"
                      [clearable]="false"
                      bindLabel="name"
                      bindValue="value"
                      groupBy="region"
                      (change)="updateAgent(lead, indx)"
                      *ngIf="!lead.loadingupdateAgent"
                      >
                      <ng-template ng-label-tmp let-item="item" *ngIf="lead.agent_id == 0">
                        Select Agent
                      </ng-template>
                      <ng-template ng-optgroup-tmp let-item="item" let-index="index">
                        {{ item.region }}
                      </ng-template>
                      <ng-template ng-option-tmp let-item="item" let-index="index">
                        {{ item.name }}
                      </ng-template>
                    </ng-select>
                  </div>

                  <!-- Action loader and Message -->
                  <i class="fa fa-spinner fa-spin" *ngIf="lead.loadingupdateAgent"></i>
                  <p class="actionUpdated" *ngIf="lead.agentUpdated">Updated</p>
                </td>

                <td>
                  <div class="pos-rel">
                    <div class="fields-m select-m" [ngClass]="{'disposition-open': lead.status == -1, 'disposition-close': lead.status != -1}" *ngIf="!lead.loadingupdateStatus">
                      <!-- Get Status Items from Pipe 'filterOrderStatus' -->
                      <ng-select
                        [items]="lead | filterOrderStatus"
                        placeholder="Order Status"
                        [(ngModel)]="lead.status"
                        [ngModelOptions]="{standalone: true}"
                        [searchable]="false"
                        [clearable]="false"
                        bindLabel= "name"
                        bindValue="value"
                        [ngClass]="{'no-change': paid == 0}"
                        (change)="updateOrder_StatusSub(lead, indx)"
                        >
                        <ng-template ng-option-tmp let-item="item" let-index="index">
                          {{ item.name }}
                        </ng-template>
                      </ng-select>
                    </div>
                  </div>

                  <!-- Action Loader and Message -->
                  <i class="fa fa-spinner fa-spin" *ngIf="lead.loadingupdateStatus"></i>
                  <p class="actionUpdated" *ngIf="lead.orderStatusUpdated">Updated</p>
                </td>

                <td>
                  <div class="order-manag-options">
                    <a href="javascript:;" routerLink="/modify-order/{{ lead.id | base64 }}" class="edit">
                      <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M17.7051 0.805083C16.6298 -0.268361 14.8884 -0.268361 13.8131 0.805083L12.8388 1.78468L2.46786 12.1501L2.44582 12.1723C2.44048 12.1777 2.44048 12.1833 2.4348 12.1833C2.42378 12.1999 2.40725 12.2162 2.3964 12.2328C2.3964 12.2383 2.39072 12.2383 2.39072 12.2438C2.3797 12.2603 2.37436 12.2713 2.36317 12.2879C2.35783 12.2934 2.35783 12.2987 2.35232 12.3044C2.34681 12.3209 2.3413 12.3319 2.33562 12.3485C2.33562 12.3538 2.33028 12.3538 2.33028 12.3595L0.0292825 19.2789C-0.0382167 19.4758 0.0130965 19.694 0.161354 19.8402C0.26553 19.943 0.406038 20.0005 0.552229 20C0.61198 19.999 0.671214 19.9897 0.728381 19.9724L7.6424 17.6659C7.64774 17.6659 7.64774 17.6659 7.65342 17.6606C7.67081 17.6554 7.68751 17.648 7.70284 17.6384C7.70714 17.6379 7.71093 17.636 7.71403 17.633C7.73039 17.622 7.75243 17.6108 7.76896 17.5998C7.78532 17.589 7.80202 17.5724 7.81855 17.5614C7.82406 17.5557 7.8294 17.5557 7.8294 17.5504C7.83508 17.5449 7.8461 17.5395 7.85161 17.5284L19.1968 6.18315C20.2703 5.10781 20.2703 3.36644 19.1968 2.29127L17.7051 0.805083ZM7.46625 16.3723L3.63498 12.5412L13.2242 2.95197L17.0554 6.78307L7.46625 16.3723ZM3.09533 13.5595L6.4424 16.9064L1.41646 18.5798L3.09533 13.5595ZM18.4207 5.41242L17.8372 6.00149L14.0057 2.17005L14.595 1.58115C15.2395 0.937154 16.2842 0.937154 16.9289 1.58115L18.4261 3.07836C19.0658 3.7258 19.0634 4.76808 18.4207 5.41242Z"
                          fill="#F07527" />
                      </svg>
                    </a>
                    <a href="javascript:;">
                      <svg width="19" height="25" viewBox="0 0 19 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15.1998 10.577H3.7998V11.5385H15.1998V10.577Z" fill="#F07527" />
                        <path d="M15.1998 13.4616H3.7998V14.4231H15.1998V13.4616Z" fill="#F07527" />
                        <path d="M15.1998 16.3462H3.7998V17.3078H15.1998V16.3462Z" fill="#F07527" />
                        <path d="M9.4998 19.2309H3.7998V20.1924H9.4998V19.2309Z" fill="#F07527" />
                        <path d="M9.51426 3.60579C9.90776 3.60579 10.2268 3.28291 10.2268 2.88463C10.2268 2.48634 9.90776 2.16347 9.51426 2.16347C9.12075 2.16347 8.80176 2.48634 8.80176 2.88463C8.80176 3.28291 9.12075 3.60579 9.51426 3.60579Z"
                          fill="#F07527" />
                        <path
                          d="M18.9999 5.7692C18.9999 4.70711 18.1493 3.84611 17.1 3.84611H14.4623C14.1105 3.4505 13.6585 3.14779 13.1392 2.99659C12.7018 2.8693 12.3651 2.52856 12.2393 2.08583C11.897 0.881254 10.8002 0 9.49994 0C8.19975 0 7.10297 0.881194 6.76073 2.08571C6.63474 2.52898 6.29725 2.8693 5.8593 2.99707C5.3406 3.14839 4.88906 3.4508 4.5375 3.84611H1.9C0.850606 3.84611 0 4.70711 0 5.7692V23.0769C0 24.139 0.850606 25 1.9 25C6.26204 25 11.6231 25 17.1 25C18.1494 25 19 24.139 19 23.0769C19 17.6154 18.9999 12.3856 18.9999 5.7692ZM4.75006 5.75369C4.75659 4.90838 5.32089 4.15477 6.12239 3.92099C6.87705 3.70092 7.45697 3.11414 7.67368 2.35151C7.90626 1.53306 8.65723 0.961543 9.49994 0.961543C10.3427 0.961543 11.0937 1.53306 11.3262 2.35157C11.543 3.11468 12.1226 3.70128 12.8765 3.92069C13.6851 4.15609 14.2499 4.91625 14.2499 5.76914V6.73068H4.75006V5.75369ZM17.1 24.0385C12.0261 24.0385 6.96053 24.0385 1.9 24.0385C1.37613 24.0385 0.95 23.6071 0.95 23.0769V5.7692C0.95 5.23903 1.37613 4.80766 1.9 4.80766H3.96281C3.86009 5.10165 3.80261 5.41721 3.80012 5.74618V7.69229H15.2V5.7692C15.2 5.43176 15.1411 5.10868 15.0359 4.80766H17.1C17.6238 4.80766 18.0499 5.23903 18.0499 5.7692C18.0499 8.51819 18.0499 21.4095 18.0501 23.0769C18.05 23.6071 17.6239 24.0385 17.1 24.0385Z"
                          fill="#F07527" />
                      </svg>
                    </a>
                  </div>
                </td>
              </tr>
            </tbody>
          </ng-container>

          <!-- For QA -->
          <ng-container *ngIf="activeUser.is_qualityassurance && (leads.data && leads.data.length > 0)">
            <tbody>
              <tr *ngFor="let lead of leads.data; let indx = index">
                <td>{{ indx + 1 }}</td>
                <td><a class="id" href="javascript:;" target="_blank" routerLink="/order-detail/{{ lead.id | base64 }}">{{ lead.order_id }}</a></td>

                <td>
                  <p class="time-done" *ngIf="lead.date">{{ lead.date | date }}</p>
                  <p class="time-done">{{ lead.date | date:'shortTime' }}</p>
                </td>
                <td>
                  <p>{{ lead.name }}   </p>
                    <!-- <div class="pos-rel" *ngIf="lead.many_order; else one">
                      <a href="javascript:;" (click)="showManyOrder(lead, indx)">
                        {{ lead.name }}
                      </a>
                      <ng-template #one>
                        
                      </ng-template> -->
                      <!-- <div class="comment-modal-m">
                        <div class="modal fade" [id]="'many_order_modal' + indx" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel1" aria-hidden="true">
                          <div class="modal-dialog" role="document">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                              <span aria-hidden="true">&times;</span>
                            </button>
                            <div class="modal-header">
                              <h5 class="modal-title" id="exampleModalLabel1" [ngClass]="{'w-100': qaComments.length == 0}" *ngIf="agentComments.length > 0">
                                Agent Comments
                              </h5>
                              <h5 class="modal-title qa-comment" id="exampleModalLabel1" [ngClass]="{'w-100': agentComments.length == 0}" *ngIf="qaComments.length > 0">
                                Q/A Comments
                              </h5>
                            </div>
                            <div class="modal-content">
                              <div class="modal-body">
                                <div class="comments-sub" [ngClass]="{'w-100': qaComments.length == 0}" *ngIf="agentComments.length > 0">
                                  <ng-container *ngFor="let comment of agentComments">
                                    <div class="comment-box">
                                      <label *ngIf="agents">{{ agentSearch(comment.user_id, agents) }}</label>
                                      <p>{{ comment.notes }}</p>
                                      <span class="date-comment">{{ comment.date | customDatePipe: 'dateTime' }}</span>
                                    </div>
                                  </ng-container>
                                </div>
                                <div class="comments-sub qa-box" [ngClass]="{'w-100': agentComments.length == 0}" *ngIf="qaComments.length > 0">
                                  <ng-container *ngFor="let comment of qaComments">
                                    <div class="comment-box">
                                      <label *ngIf="agents">{{ agentSearch(comment.user_id, qa) }}</label>
                                      <p [innerHtml]="comment.notes | safeHtml: 'html'"></p>
                                      <span class="date-comment">{{ comment.date | customDatePipe: 'dateTime' }}</span>
                                    </div>
                                  </ng-container>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div> -->
                    
                    <!-- </div> -->
                    
          
                  <p>{{ lead.phone }}</p>
                  <p>{{ lead.email }}</p>
                </td>
                <td>
                  <p class="price-td" [ngClass]="{'fullpay': !lead.half_price, 'halfpay': lead.half_price}">$ {{ lead.amount }}</p>
                  <p class="page-td">{{ lead.pages }} Pages</p>
                </td>
                <td>
                  <p>{{ lead.work_type | capitalize }}</p>
                </td>
                <td>

                  <p *ngIf="lead.delivery_date == '0000-00-00 00:00:00'">-</p>
                  <ng-container *ngIf="lead.delivery_date != '0000-00-00 00:00:00'">
                    <p>{{ lead.delivery_date | date }}</p>
                    <p>{{ lead.delivery_date | date:'shortTime' }}</p>
                  </ng-container>
                  <p [ngClass]="{'time-elapsed': lead.show_red_dd, 'time-left': !lead.show_red_dd}" *ngIf="lead.time_remaining_dd;else showDash">{{ lead.time_remaining_dd }}</p>
                  <ng-template #showDash>-</ng-template>

                </td>
                <td>
                  {{agentSearch(lead.writer_id ,writers)}}
                </td>
                <td>
                  <p *ngIf="lead.writer_delivery_date == '0000-00-00 00:00:00'">-</p>
                  <ng-container *ngIf="lead.writer_delivery_date != '0000-00-00 00:00:00'">
                    <p>{{ lead.writer_delivery_date | date }}</p>
                    <p>{{ lead.writer_delivery_date | date:'shortTime' }}</p>
                  </ng-container>
                  <p [ngClass]="{'time-elapsed': lead.show_red, 'time-left': !lead.show_red}" *ngIf="lead.time_remaining;else showDash">{{ lead.time_remaining }}</p>
                  <ng-template #showDash>-</ng-template>
                </td>
                <td>
                  <label class="agent-label" *ngFor="let singleAgent of lead.agent.split(',')">{{ singleAgent }}</label>
                </td>
                <td>
                  <p class="roundedShape">
                    <ng-container *ngFor="let status of orderStatus">
                      <!-- <span class="underReviewBox" *ngIf="status.value == lead.status">{{ status.name }}</span> -->
                      <span class="{{status.color}}" *ngIf="status.value == lead.status">{{ status.name }}</span>
                    </ng-container>
                  </p>
                </td>
                <td>
                  <div class="pos-rel">
                    <a href="javascript:;" *ngIf="!lead.markingVerify" (click)="setVerifiedStatusId(lead, indx)" [ngClass]="{'inactive': !lead.verified_sales}">
                      <svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M6.15584 12.4036C6.6111 11.5714 7.1148 10.7667 7.66435 9.99343C9.52238 7.43058 11.8086 5.30168 14.3422 3.42453C16.0268 2.17128 17.8082 1.05343 19.6697 0.0814906C19.8724 -0.0243497 20.0161 -0.0372017 20.2113 0.103415C20.5956 0.380111 21.0026 0.623544 21.4286 0.897973C20.4611 1.55904 19.5291 2.27041 18.6362 3.02914C15.3332 5.86566 12.612 9.20114 10.2305 12.8262C8.93947 14.7748 7.78016 16.8074 6.7603 18.9105C6.69373 19.0496 6.62261 19.1509 6.45013 19.1978C5.5423 19.4457 4.64203 19.7103 3.74025 19.9734C3.56474 20.0241 3.46109 20.0218 3.44445 19.7897C3.26894 17.2601 2.53662 14.8674 1.62879 12.52C1.17326 11.3372 0.652473 10.1805 0.0688346 9.05523C-0.0355659 8.85414 -0.0446442 8.76947 0.208792 8.69387C1.10679 8.41868 1.99873 8.12157 2.88689 7.81539C3.09494 7.73979 3.20161 7.8101 3.33022 7.95828C4.48466 9.29391 5.43668 10.7916 6.15584 12.4036Z"
                          fill="#00A5DC" />
                      </svg>
                    </a>

                    <!-- Loader for Action and Message -->
                    <i class="fa fa-spinner fa-spin" aria-hidden="true" *ngIf="lead.markingVerify"></i>
                    <p class="actionUpdated" *ngIf="lead.verifyUpdated">Updated</p>

                    <!-- Mark verified -->
                    <div class="paid-modal-m deleteModal">
                      <div class="modal fade" [id]="'markVerified'+ indx" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel2" aria-hidden="true">
                        <div class="modal-dialog" role="document">
                          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                          </button>
                          <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel2">
                              Are you sure you want to mark it
                              <span *ngIf="!lead.verified_sales">Verfied?</span>
                              <span *ngIf="lead.verified_sales">Unverfied?</span>
                            </h5>
                          </div>
                          <div class="modal-content">
                            <div class="modal-body">
                              <div class="action-btns">
                                <a href="javascript:;" data-dismiss="modal" aria-label="Close">NO</a>
                                <a href="javascript:;" class="yes-btn" [ngClass]="{'bgBlue': !lead.verified_sales, 'bgRed': lead.verified_sales}" (click)="setVerifiedStatus(indx, lead)">YES</a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </td>

                <td>
                  <ng-container *ngIf="lead.verified_sales">
                    <div class="fields-m select-m" [ngClass]="{'disposition-open': lead.valid_sales == 1, 'invalid': lead.valid_sales == 0, 'disposition-close': lead.valid_sales == 2}" *ngIf="!lead.updatingValid">
                      <ng-select
                        [items]="validInvalidSales"
                        placeholder="Select Valid / Invalid"
                        [(ngModel)]="lead.valid_sales"
                        [ngModelOptions]="{standalone: true}"
                        [searchable]="false"
                        [clearable]="false"
                        bindLabel="name"
                        bindValue="value"
                        (change)="updateValidInvalid(lead, indx)"
                        >
                        <ng-template ng-label-tmp let-item="item" *ngIf="lead.valid_sales == 2">
                          Select Valid / Invalid
                        </ng-template>

                        <ng-template ng-option-tmp let-item="item" let-index="index">
                          {{ item.name }}
                        </ng-template>
                      </ng-select>
                    </div>

                    <!-- Action loader and Message -->
                    <i class="fa fa-spinner fa-spin" *ngIf="lead.updatingValid"></i>
                    <p class="actionUpdated" *ngIf="lead.valUpdated">Updated</p>
                  </ng-container>

                  <p *ngIf="lead.verified_sales == 0">-</p>
                </td>

                <td>
                  <div class="pos-rel">
                    <a href="javascript:;" (click)="showQAComments(lead, indx)">
                      <div class="stars genralFeedback" *ngIf="!lead.qaComLoader">
                        <i class="fa fa-star" aria-hidden="true" [ngClass]="{'active': parseFloatCustom(lead.rating) >= 1 , 'active-half': parseFloatCustom(lead.rating) > 0 && parseFloatCustom(lead.rating) < 1 }"></i>
                        <i class="fa fa-star" aria-hidden="true" [ngClass]="{'active': parseFloatCustom(lead.rating) >= 2 , 'active-half': parseFloatCustom(lead.rating) > 1 && parseFloatCustom(lead.rating) < 2 }"></i>
                        <i class="fa fa-star" aria-hidden="true" [ngClass]="{'active': parseFloatCustom(lead.rating) >= 3 , 'active-half': parseFloatCustom(lead.rating) > 2 && parseFloatCustom(lead.rating) < 3 }"></i>
                        <i class="fa fa-star" aria-hidden="true" [ngClass]="{'active': parseFloatCustom(lead.rating) >= 4 , 'active-half': parseFloatCustom(lead.rating) > 3 && parseFloatCustom(lead.rating) < 4}"></i>
                        <i class="fa fa-star" aria-hidden="true" [ngClass]="{'active': parseFloatCustom(lead.rating) >= 5 , 'active-half': parseFloatCustom(lead.rating) > 4 && parseFloatCustom(lead.rating) < 5}"></i>
                      </div>
                    </a>

                    <!-- Action Loader and Message -->
                    <i class="fa fa-spinner fa-spin qaLoaderIcon" aria-hidden="true" *ngIf="lead.qaComLoader"></i>

                    <!-- Add QA feedback modal -->
                    <div class="prfModal setModalPosition notesModal mainModal qa-lead">
                      <div class="modal fade" [id]="'addQAFeedback' + indx" tabindex="-1" role="dialog" aria-hidden="true">
                        <div class="modal-dialog" role="document">
                          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                          </button>
                          <div class="modal-header">
                            <h5 class="modal-title">Q/A Feedback</h5>
                          </div>
                          <div class="modal-content">
                            <div class="modal-body">
                              <div class="submitCopy" style="padding: 0;">
                                <!-- <div class="ratingWrap">
                                    <span>Rating:</span>
                                    <div class="stars">
                                      <i class="fa fa-star" [ngClass]="{'active': rating_val >= 1}" (click)="setRating(1)"></i>
                                      <i class="fa fa-star" [ngClass]="{'active': rating_val >= 2}" (click)="setRating(2)"></i>
                                      <i class="fa fa-star" [ngClass]="{'active': rating_val >= 3}" (click)="setRating(3)"></i>
                                      <i class="fa fa-star" [ngClass]="{'active': rating_val >= 4}" (click)="setRating(4)"></i>
                                      <i class="fa fa-star" [ngClass]="{'active': rating_val >= 5}" (click)="setRating(5)"></i>
                                    </div>
                                </div> -->

                                <div class="ratingWrap">
                                    <div class="invalid-Reason edit_price">
                                      <span>Rating</span>
                                      <input type="number" [(ngModel)]="rating_val" min="0" max="5">
                                    </div>

                                    <ng-template #t let-fill="fill">
                                      <i class="fa fa-star ratingFullStar" [class.active]="fill === 100">
                                        <i class="fa fa-star ratingHalfStar" [style.width.%]="fill"></i>
                                      </i>
                                    </ng-template>
                                    <ngb-rating class="ngbRating qaRate" [(rate)]="rating_val" [starTemplate]="t" [readonly]="true" [max]="5"></ngb-rating>
                                </div>

                                <form [formGroup]="addCommentForm">
                                    <div class="invalid-Reason">
                                        <span>Feedback</span>
                                        <textarea class="textarea" [(ngModel)]="qa_feedback_note" formControlName="qaFeedback" [ngClass]="{ 'is-invalid': submitted && f.qaFeedback.errors }" placeholder="Enter Feedback / comments for Support." name="name" rows="5"></textarea>
                                    </div>
                                    <div class="action-btns">
                                        <button (click)="addQAFeedback(lead, indx)" [disabled]="qaLoader"><i class="fa fa-spinner fa-spin" *ngIf="qaLoader"></i> Save</button>
                                    </div>
                                </form>
                              </div>

                              <h5 class="modal-title" *ngIf="qaComments && qaComments.length > 0">All Previous Feedbacks</h5>
                              <ul class="allNotes comment-box" *ngIf="qaComments">
                                  <li *ngFor="let comment of qaComments">
                                    <label>{{ agentSearch(comment.user_id, qa) }}</label>
                                    <p class="p-0 text-left" [innerHtml]="comment.notes"></p>
                                    <span class="date-comment">{{ comment.date | customDatePipe: 'shortTime'}}</span>
                                  </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
                <td>
                  <div class="pos-rel">
                    <a href="javascript:;" (click)="showComments(lead,indx)" >
                      <svg width="25" height="20" viewBox="0 0 25 20" fill="none" xmlns="http://www.w3.org/2000/svg" *ngIf="loader != lead.id" >
                        <path d="M19.873 0H5.12695C2.29988 0 0 2.23443 0 4.98105V12.6743C0 14.8659 1.48106 16.7747 3.6272 17.3857L6.10332 19.7915C6.24084 19.925 6.427 20 6.62136 20C6.81553 20 7.00188 19.925 7.13921 19.7915L9.41067 17.5845H19.873C22.7001 17.5845 25 15.3501 25 12.6035V4.98105C25 2.23443 22.7001 0 19.873 0ZM23.5352 12.6035C23.5352 14.5653 21.8924 16.1614 19.873 16.1614H9.1074C8.91323 16.1614 8.72688 16.2364 8.58955 16.3698L6.62136 18.282L4.52518 16.2455C4.43115 16.1541 4.31328 16.0893 4.18415 16.0581C2.58312 15.671 1.46484 14.2796 1.46484 12.6743V4.98105C1.46484 3.01921 3.10764 1.42316 5.12695 1.42316H19.873C21.8924 1.42316 23.5352 3.01921 23.5352 4.98105V12.6035Z" fill="#00A5DC"/>
                        <path d="M17.1506 6.82312H7.84961C7.44506 6.82312 7.11719 7.14185 7.11719 7.5347C7.11719 7.92774 7.44506 8.24628 7.84961 8.24628H17.1506C17.5552 8.24628 17.883 7.92774 17.883 7.5347C17.883 7.14185 17.5552 6.82312 17.1506 6.82312Z" fill="#00A5DC"/>
                        <path d="M17.1506 9.33826H7.84961C7.44506 9.33826 7.11719 9.6568 7.11719 10.0498C7.11719 10.4429 7.44506 10.7614 7.84961 10.7614H17.1506C17.5552 10.7614 17.883 10.4429 17.883 10.0498C17.883 9.6568 17.5552 9.33826 17.1506 9.33826Z" fill="#00A5DC"/>
                      </svg>
                      <i class="fa fa-spinner fa-spin" aria-hidden="true" *ngIf="loader == lead.id"></i>
                    </a>
                    <div class="comment-modal-m">
                      <div class="modal fade" [id]="'comment_modal'+indx" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel1" aria-hidden="true">
                        <div class="modal-dialog" role="document">
                          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                          </button>
                          <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel1" [ngClass]="{'w-100': qaComments.length == 0}" *ngIf="agentComments.length > 0">Agent Comments</h5>
                            <h5 class="modal-title qa-comment" id="exampleModalLabel1" [ngClass]="{'w-100': agentComments.length == 0}" *ngIf="qaComments.length > 0">Q/A Comments</h5>
                          </div>
                          <div class="modal-content">
                            <div class="modal-body">
                              <div class="comments-sub" [ngClass]="{'w-100': qaComments.length == 0}" *ngIf="agentComments.length > 0">
                                <ng-container *ngFor="let comment of agentComments">
                                  <div class="comment-box">
                                    <label *ngIf="agents">{{ agentSearch(comment.user_id, agents) }}</label>
                                    <p>{{ comment.notes }}</p>
                                    <span class="date-comment">{{ comment.date | customDatePipe: 'dateTime' }}</span>
                                  </div>
                                </ng-container>

                              </div>
                              <div class="comments-sub qa-box" [ngClass]="{'w-100': agentComments.length == 0}" *ngIf="qaComments.length > 0">
                                <ng-container *ngFor="let comment of qaComments">
                                  <div class="comment-box">
                                    <label *ngIf="agents">{{ agentSearch(comment.user_id, qa) }}</label>
                                    <p [innerHtml]="comment.notes | safeHtml: 'html'"></p>
                                    <span class="date-comment">{{ comment.date | customDatePipe: 'dateTime' }}</span>
                                  </div>
                                </ng-container>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </ng-container>
        </table>
      </div>
    </div>

    <div class="paid-modal-m">
      <div class="modal fade" id="paid_modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel2" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel2">Are you sure you want to mark it as paid?</h5>
          </div>
          <div class="modal-content">
            <div class="modal-body">
              <div class="action-btns">
                <a href="javascript:;" data-dismiss="modal" aria-label="Close" (click)="checkClass('no')">NO</a>
                <a href="javascript:;" data-dismiss="modal" aria-label="Close" class="yes-btn" (click)="checkClass('yes')">YES</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="revisionComments-m qa-feedbackN">
      <div class="modal fade" id="qa-feedback" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          <div class="modal-header">
            <h5 class="modal-title">Q/A Feedback</h5>
          </div>
          <div class="modal-content">
            <div class="modal-body">
              <div class="revisionComment">
                <div class="qaRating">
                  <label>Rating:</label>
                  <div class="stars">
                    <i class="fa fa-star" aria-hidden="true"></i>
                    <i class="fa fa-star" aria-hidden="true"></i>
                    <i class="fa fa-star" aria-hidden="true"></i>
                    <i class="fa fa-star" aria-hidden="true"></i>
                    <i class="fa fa-star" aria-hidden="true"></i>
                  </div>
                </div>
                <div class="validRevision">
                  <div class="invalid-Reason">
                    <span>Feedback</span>
                    <textarea name="name" placeholder="Enter Feedback / comments for Support."></textarea>
                  </div>
                </div>
                <div class="action-btns">
                  <a href="javascript:;">Save</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Submit Work modal -->
      <div class="submitCopy-m writersModal">
        <div class="modal fade" id="submitWork" tabindex="-1" role="dialog" aria-hidden="true">
          <div class="modal-dialog" role="document">
            <!-- <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button> -->
            <div class="modal-header">
              <h5 class="modal-title">
                <ng-container *ngIf="!Rev_SubWork.isUpdate">Submit </ng-container>
                <ng-container *ngIf="Rev_SubWork.isUpdate">Update </ng-container>
                Work
              </h5>
            </div>
            <div class="modal-content">
              <div class="modal-body">
                  <div class="submitCopy">
                    <div class="invalid-Reason">
                      <span>Document Note</span>
                      <textarea placeholder="Enter Feedback / comments" name="name" rows="5" [(ngModel)]="Rev_SubWork.document_note"></textarea>
                    </div>
                    <div class="attachments-copy">
                      <label>Grammarly Proofread File</label>
                      <div class="filepond-m">
                        <file-pond #Writer_Pond_Attach
                          [options]="WR_Attach_PondOptions"
                          [files]="pondFiles"
                          (oninit)="pondHandleInit()"
                          (onaddfile)="pondHandleAddFile($event)"
                          >
                        </file-pond>
                      </div>
                      <p class="errorMsg">Every Document you submit should be proofread via grammarly. Quality score must be above 90.</p>

                      <div *ngIf="Rev_SubWork.oldAttach.length > 0">
                        <ng-container *ngFor="let attach of Rev_SubWork.oldAttach">
                          <div class="attachedFiles" *ngIf="attach">
                              <div class="single">
                                  <svg width="25" height="30" viewBox="0 0 25 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M23.5714 3.97587H21.0713V1.4458C21.0714 0.650565 20.4285 0 19.6431 0H1.42853C0.642821 0 0 0.650565 0 1.4458V24.5783C0 25.3734 0.642821 26.0241 1.42859 26.0241H3.9286V28.5542C3.9286 29.3494 4.57113 30 5.35718 30H17.4997C18.285 30 19.3965 29.554 19.9683 29.0093L23.959 25.2076C24.5314 24.6629 24.9993 23.5663 24.9993 22.7711L25 5.42179C24.9999 4.62649 24.3571 3.97587 23.5714 3.97587ZM3.92848 5.42173V24.9397H1.42853C1.23498 24.9397 1.07143 24.7742 1.07143 24.5783V1.4458C1.07143 1.24992 1.23498 1.08439 1.42853 1.08439H19.6432C19.8364 1.08439 20.0003 1.24992 20.0003 1.4458V3.97593H5.35707C4.57101 3.97593 3.92848 4.62649 3.92848 5.42173ZM23.2246 24.4181L19.2339 28.2195C19.1521 28.2973 19.0457 28.3735 18.9281 28.4461V25.1204C18.9281 24.8721 19.0271 24.6487 19.1903 24.4825C19.355 24.3173 19.5757 24.2169 19.821 24.2169H23.3943C23.3388 24.293 23.2821 24.3632 23.2246 24.4181ZM23.9278 22.771C23.9278 22.8784 23.9084 23.0027 23.8792 23.1324H19.821C18.7371 23.1346 17.8589 24.0234 17.8567 25.1204V28.8718C17.7292 28.8979 17.6063 28.9155 17.4996 28.9155H5.35707V28.9156C5.16312 28.9156 4.99997 28.75 4.99997 28.5541V5.42167C4.99997 5.22579 5.16318 5.06026 5.35707 5.06026H23.5713C23.7648 5.06026 23.9284 5.22579 23.9284 5.42167L23.9278 22.771Z" fill="#868686"/>
                                  <path d="M19.6431 9.03613H9.28602C8.98994 9.03613 8.75031 9.27865 8.75031 9.5783C8.75031 9.87795 8.99 10.1205 9.28602 10.1205H19.6431C19.9388 10.1205 20.1788 9.87795 20.1788 9.5783C20.1788 9.27865 19.9388 9.03613 19.6431 9.03613Z" fill="#868686"/>
                                  <path d="M19.6431 16.2651H9.28602C8.98994 16.2651 8.75031 16.5077 8.75031 16.8073C8.75031 17.107 8.99 17.3495 9.28602 17.3495H19.6431C19.9388 17.3495 20.1788 17.107 20.1788 16.8073C20.1788 16.5076 19.9388 16.2651 19.6431 16.2651Z" fill="#868686"/>
                                  <path d="M15.0002 19.8794H9.28602C8.98994 19.8794 8.75031 20.1219 8.75031 20.4216C8.75031 20.7212 8.98994 20.9637 9.28602 20.9637H15.0002C15.296 20.9637 15.5356 20.7212 15.5356 20.4216C15.5356 20.1219 15.296 19.8794 15.0002 19.8794Z" fill="#868686"/>
                                  <path d="M19.6431 12.6504H9.28602C8.98994 12.6504 8.75031 12.8929 8.75031 13.1926C8.75031 13.4922 8.99 13.7347 9.28602 13.7347H19.6431C19.9388 13.7347 20.1788 13.4922 20.1788 13.1926C20.1788 12.8929 19.9388 12.6504 19.6431 12.6504Z" fill="#868686"/>
                                  </svg>
                                <a [href]="DOC_URL + '/' + docs_revised_orders_path + '/' +  attach" target="_blank">{{ attach }}</a>
                                <!-- <i class="fa fa-times"></i> -->
                              </div>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                    <div class="attachments-copy">
                      <label>Turnitin Plagiarism Report</label>
                      <div class="filepond-m">
                        <file-pond #Writer_Pond_Plag
                          [options]="WR_Plag_PondOptions"
                          [files]="pondFiles"
                          (oninit)="pondHandleInit()"
                          (onaddfile)="pondHandleAddFile($event)"
                          >
                        </file-pond>
                      </div>
                      <p class="errorMsg">Stricly zero percent tolerance for plagiarism! Only Turnitin Plagiarism report is accepted. Ask Skype team for software access. Plagiarised work may result in account termination without notice or warning with zero payment for all submitted projects. Please be extra careful to avoid this. </p>

                      <div *ngIf="Rev_SubWork.oldPlag.length > 0">
                        <ng-container *ngFor="let plag of Rev_SubWork.oldPlag">
                          <div class="attachedFiles" *ngIf="plag">
                              <div class="single">
                                  <svg width="25" height="30" viewBox="0 0 25 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M23.5714 3.97587H21.0713V1.4458C21.0714 0.650565 20.4285 0 19.6431 0H1.42853C0.642821 0 0 0.650565 0 1.4458V24.5783C0 25.3734 0.642821 26.0241 1.42859 26.0241H3.9286V28.5542C3.9286 29.3494 4.57113 30 5.35718 30H17.4997C18.285 30 19.3965 29.554 19.9683 29.0093L23.959 25.2076C24.5314 24.6629 24.9993 23.5663 24.9993 22.7711L25 5.42179C24.9999 4.62649 24.3571 3.97587 23.5714 3.97587ZM3.92848 5.42173V24.9397H1.42853C1.23498 24.9397 1.07143 24.7742 1.07143 24.5783V1.4458C1.07143 1.24992 1.23498 1.08439 1.42853 1.08439H19.6432C19.8364 1.08439 20.0003 1.24992 20.0003 1.4458V3.97593H5.35707C4.57101 3.97593 3.92848 4.62649 3.92848 5.42173ZM23.2246 24.4181L19.2339 28.2195C19.1521 28.2973 19.0457 28.3735 18.9281 28.4461V25.1204C18.9281 24.8721 19.0271 24.6487 19.1903 24.4825C19.355 24.3173 19.5757 24.2169 19.821 24.2169H23.3943C23.3388 24.293 23.2821 24.3632 23.2246 24.4181ZM23.9278 22.771C23.9278 22.8784 23.9084 23.0027 23.8792 23.1324H19.821C18.7371 23.1346 17.8589 24.0234 17.8567 25.1204V28.8718C17.7292 28.8979 17.6063 28.9155 17.4996 28.9155H5.35707V28.9156C5.16312 28.9156 4.99997 28.75 4.99997 28.5541V5.42167C4.99997 5.22579 5.16318 5.06026 5.35707 5.06026H23.5713C23.7648 5.06026 23.9284 5.22579 23.9284 5.42167L23.9278 22.771Z" fill="#868686"/>
                                  <path d="M19.6431 9.03613H9.28602C8.98994 9.03613 8.75031 9.27865 8.75031 9.5783C8.75031 9.87795 8.99 10.1205 9.28602 10.1205H19.6431C19.9388 10.1205 20.1788 9.87795 20.1788 9.5783C20.1788 9.27865 19.9388 9.03613 19.6431 9.03613Z" fill="#868686"/>
                                  <path d="M19.6431 16.2651H9.28602C8.98994 16.2651 8.75031 16.5077 8.75031 16.8073C8.75031 17.107 8.99 17.3495 9.28602 17.3495H19.6431C19.9388 17.3495 20.1788 17.107 20.1788 16.8073C20.1788 16.5076 19.9388 16.2651 19.6431 16.2651Z" fill="#868686"/>
                                  <path d="M15.0002 19.8794H9.28602C8.98994 19.8794 8.75031 20.1219 8.75031 20.4216C8.75031 20.7212 8.98994 20.9637 9.28602 20.9637H15.0002C15.296 20.9637 15.5356 20.7212 15.5356 20.4216C15.5356 20.1219 15.296 19.8794 15.0002 19.8794Z" fill="#868686"/>
                                  <path d="M19.6431 12.6504H9.28602C8.98994 12.6504 8.75031 12.8929 8.75031 13.1926C8.75031 13.4922 8.99 13.7347 9.28602 13.7347H19.6431C19.9388 13.7347 20.1788 13.4922 20.1788 13.1926C20.1788 12.8929 19.9388 12.6504 19.6431 12.6504Z" fill="#868686"/>
                                  </svg>
                                <a [href]="DOC_URL + '/' + docs_revised_orders_path + '/' +  plag" target="_blank">{{ plag }}</a>
                                <!-- <i class="fa fa-times"></i> -->
                              </div>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                    <div class="action-btns">
                      <button (click)="submitRevWork()" [disabled]="Rev_ActionLoader || Rev_FileLoader">
                        <i class="fa fa-spinner fa-spin" *ngIf="Rev_ActionLoader"></i>
                        Submit
                      </button>
                    </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    <!-- Submit Work modal -->

  </div>
</section>
